module.exports = __webpack_public_path__ + "static/media/issue-new.9af535ae.svg";